import React from 'react'
import {Header, List} from 'semantic-ui-react'

const SecureMock = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Secure Mock</Header>
      <p>
        There may be cases where you are collaborating on a mock with an external partner. When doing so it may
        be desirable to make sure the mock is only accessible to this trusted partner. To do so you need to
        enable security which will require the displayed key be provided in the "x-smocks-api-key" header.
      </p>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed divided>
        <List.Item>1. Navigate to the service you wish to work with.</List.Item>
        <List.Item>2. Click the "Edit" icon.</List.Item>
        <List.Item>3. Toggle on "API Key Required" in the modal that appears.</List.Item>
        <List.Item>4. Click the "Update" button.</List.Item>
        <List.Item>5. Expand the environment you want to work with and copy the "API Key" that is displayed.</List.Item>
        <List.Item>6. Provide this key to any callers to supply in the "x-smocks-api-key" header.</List.Item>
      </List>
    </div>
  )
}

export {SecureMock}

export default SecureMock